import apiClient from '@/service';
import { defineStore } from 'pinia';
import type { IMyInfo } from '@/types';
import type { ICompany } from '@/modules/admin/company/type';
import type { CommonCodeGroup } from '@/types/CommonCode';
import { useCommonStore } from '@/store/commonStore';
import { useAppStore } from './appStore';

export const useMyPageStore = defineStore('MyPageStore', {
  state: () => ({
    myInfo: {} as IMyInfo,
    companyList: [] as ICompany[],
    positionList: {} as CommonCodeGroup,
    authorityTypeList: {} as CommonCodeGroup,
  }),
  getters: {
    isAdmin: (state) => {
      return state.myInfo.authority === state.authorityTypeList.M.value;
    },
  },
  actions: {
    async initializePositionList() {
      const commonStore = useCommonStore();
      const { PS, AT } = await commonStore.fetchCommonCodes(['PS', 'AT']);
      this.positionList = PS;
      this.authorityTypeList = AT;
    },
    updateMyInfo(isGetMenuList = true) {
      return apiClient
        .get<IMyInfo>('/user/info')
        .then(({ data: { data } }) => {
          this.myInfo = data;
          if (isGetMenuList) {
            setTimeout(() => {
              useAppStore().getMenuList(data.code);
            }, 0);
          }
        })
        .catch(errorHandler);
    },
    getCompanyList() {
      return apiClient
        .get<ICompany[]>(`/company/user/${this.myInfo.code}/authority?userCompanyAuthorityYn=Y`)
        .then(({ data: { data } }) => {
          this.companyList = data;
        })
        .catch(errorHandler);
    },
    setMyInfo(params: { cellPhone: string; email: string }) {
      return apiClient
        .put<IMyInfo>(`/user/my/${this.myInfo.code}`, params)
        .then(() => {
          return true;
        })
        .catch((err) => {
          errorHandler(err);
          return false;
        });
    },
    changePassword(params: { oldPasswd: string; passwd: string }) {
      return apiClient
        .put<IMyInfo>(`/user/${this.myInfo.code}/passwd`, params)
        .then(() => {
          return true;
        })
        .catch((err) => {
          errorHandler(err);
          return false;
        });
    },
  },
});
